export const CHANGE_USER_COUNTRIES_REQUEST = 'CHANGE_USER_COUNTRIES_REQUEST';
export const CHANGE_USER_COUNTRIES_SUCCESS = 'CHANGE_USER_COUNTRIES_SUCCESS';
export const CHANGE_USER_COUNTRIES_FAILED = 'CHANGE_USER_COUNTRIES_FAILED';

export const GET_SUB_USERS_LIST_REQUEST = 'GET_SUB_USERS_LIST_REQUEST';
export const GET_SUB_USERS_LIST_SUCCESS = 'GET_SUB_USERS_LIST_SUCCESS';
export const GET_SUB_USERS_LIST_FAILED = 'GET_SUB_USERS_LIST_FAILED';

export const changeUserCountriesActions = (data:any) => {
    return { type: CHANGE_USER_COUNTRIES_REQUEST, payload: data};
};

export const getSubUsersList = () => {
    return { type: GET_SUB_USERS_LIST_REQUEST };
}
